import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPassport: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPassport"><Path d="M9 16.5H15M4 3H20V21H4V3ZM15.25 10.5C15.25 12.2949 13.7949 13.75 12 13.75C10.2051 13.75 8.75 12.2949 8.75 10.5C8.75 8.70507 10.2051 7.25 12 7.25C13.7949 7.25 15.25 8.70507 15.25 10.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPassport;
